module.exports = __webpack_public_path__ + "static/media/proj19_img1.1176884a.jpg";